import React from "react"
import { Spin } from "antd"

const AnalyticsAdmin = ({ data, loading }) => {
  const lang = localStorage.getItem("language") || "ar"

  const totalLogins = data?.admin_login_analytics?.summary?.total_logins ?? 0

  if (loading) {
    return (
      <div className="analytics-loading">
        <Spin size="large" />
      </div>
    )
  }

  const {
    total_users = 0,
    total_paid_users = 0,
    total_unpaid_users = 0,
    total_active_users = 0,
    total_returning_users = 0,
    total_revenue = 0,
  } = data || {}

  // The summary payload names this counter differently across versions.
  const totalRenewalSubscriptions =
    [
      "total_renewal_subscriptions",
      "total_renewals",
      "total_renewed_subscriptions",
      "renewal_subscriptions_count",
    ].map((k) => data?.[k]).find((v) => v !== undefined && v !== null) ?? 0

  // const chartDataSets = [
  //   [264, 417, 438, 887, 309, 397, 550],
  //   [150, 230, 410, 690, 520, 430, 470],
  //   [120, 280, 360, 460, 640, 690, 530],
  //   [700, 540, 480, 320, 260, 390, 510],
  //   [180, 260, 340, 410, 550, 490, 450],
  // ]

  const metrics = [
    {
      title: lang === "ar" ? "إجمالي المستخدمين" : "Total Users",
      value: total_users,
      color: "#8B5CF6",
      img: "/dashboard/Chart-purple.svg",
    },
    {
      title: lang === "ar" ? "المستخدمون النشطون" : "Active Users",
      value: total_active_users,
      color: "#3B82F6",
      img: "/dashboard/Chart-green.svg",
    },
    {
      title: lang === "ar" ? "المستخدمون المشتركين" : "Paid Users",
      value: total_paid_users,
      color: "#22C55E",
      img: "/dashboard/chart-blue.svg",
    },
    {
      title: lang === "ar" ? "عدد تسجيلات الدخول" : "Login Count",
      value: totalLogins,
      color: "#308AA3",
      img: "/dashboard/chart-teal.svg",
    },
    {
      title: lang === "ar" ? "المستخدمون غير المشتركين" : "Unpaid Users",
      value: total_unpaid_users,
      color: "#EF4444",
      img: "/dashboard/Chart-green.svg",
    },
    {
      title: lang === "ar" ? "المستخدمون العائدون" : "Returning Users",
      value: total_returning_users,
      color: "#F59E0B",
      img: "/dashboard/chart-red.svg",
    },
    {
      title:
        lang === "ar"
          ? "الاشتراكات المُجدَّدة"
          : "Renewal Subscriptions",
      value: totalRenewalSubscriptions,
      color: "#0EA5E9",
      img: "/dashboard/chart-teal.svg",
    },
    {
      title: lang === "ar" ? "إجمالي الإيرادات" : "Total Revenue",
      value: total_revenue,
      color: "#F8B02B",
      img: "/dashboard/chart-amber.svg",
    },
  ]

  // const getChartConfig = (color, data) => ({
  //   data: data.map((value, index) => ({ value, index })),
  //   width: 200,
  //   height: 80,
  //   xField: "index",
  //   yField: "value",
  //   smooth: true,
  //   tooltip: false,
  //   axis: false,
  //   style: {
  //     fill: `l(270) 0:#fff 1:${color}`,
  //     fillOpacity: 0.6,
  //     stroke: color,
  //     lineWidth: 2,
  //     lineJoin: "round",
  //     lineCap: "round",
  //   },
  // })

  return (
    <div className="analytics-container">
      <div className="analytics-grid">
        {metrics.map((item, idx) => (
          <div className="analytics-card" key={idx}>
            <div className="analytics-card-content">
              <p className="analytics-card-title">{item.title}</p>
              <h3 className="analytics-card-value">{item.value}</h3>
            </div>
            <div className="analytics-chart-clip">
              {/* ⛔ Chart removed
              <Tiny.Area {...getChartConfig(item.color, chartDataSets[idx])} /> 
              */}
              {/* ✅ Image added instead */}
              <img
                src={item.img}
                alt={item.title}
                className="analytics-card-image"
              />
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}

export default AnalyticsAdmin
